import { Theme, ThemeOptions } from '@mui/material';
import { colors } from './colors';

export const fonts = {
  heading:
    'Alegreya Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,Open Sans, Helvetica Neue, sans-serif',
  body: 'Nunito Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,Open Sans, Helvetica Neue, sans-serif',
};

export const typographyStyles = (theme: Theme): ThemeOptions => ({
  /**
   * Responsive Font Sizes
   */
  typography: {
    h1: {
      fontFamily: fonts.heading,
      fontSize: '2.25rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '2.5rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '3rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '3.5rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '4rem',
      },
    },
    h2: {
      fontFamily: fonts.heading,
      fontSize: '2rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '2.25rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2.75rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '3rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '3.5rem',
      },
    },
    h3: {
      fontFamily: fonts.heading,
      fontSize: '1.75rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '2rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2.5rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '2.75rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '3rem',
      },
    },
    h4: {
      fontFamily: fonts.heading,
      fontSize: '1.5rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.75rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2.25rem',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '2.5rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '2.75rem',
      },
    },
    h5: {
      fontFamily: fonts.heading,
      fontSize: '1.25rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '2.25rem',
      },
    },
    h6: {
      fontFamily: fonts.heading,
      fontSize: '1.125rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.25rem',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '1.5rem',
      },
    },
    large: {
      fontFamily: fonts.body,
      fontSize: '1.25rem',
      fontWeight: 400,
    },
    medium: {
      fontFamily: fonts.body,
      fontSize: '.875rem',
      fontWeight: 400,
    },
    small: {
      fontFamily: fonts.body,
      fontSize: '.8125rem',
      fontWeight: 400,
    },
    display6: {
      fontFamily: fonts.heading,
      fontSize: '1.25rem',
      fontWeight: 700,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
    },
    paragraph: {
      fontFamily: fonts.heading,
      fontSize: '1rem',
      fontWeight: 400,
      [theme.breakpoints.up('lg')]: {
        fontSize: '1.125rem',
      },
    },
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: { color: 'success' },
          style: {
            color: colors.success.main,
          },
        },
        {
          props: { color: 'warning' },
          style: {
            color: colors.warning.main,
          },
        },
      ],
    },
  },
});
